// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202608071504/js/" + chunkId + "." + {"44":"6f985b20","225":"f365e34a","481":"7531f054","486":"5fa5cc4d","770":"9c105774"}[chunkId] + ".0.5972805054286866.chunk.js";
};